<div class="fill white-bg">
  <div [class.pr-xsmall-b]="isSearchBarPresent">
    <fin-destination-search-header [destinationTeaserText]="destinationTeaserText"></fin-destination-search-header>
  </div>
  <fin-destination-search-form
    *ngIf="(initialDestinationSearchSelection$ | async) && !isSearchBarPresent"
    [meta]="meta"
    [initialDestinationSearchSelection$]="initialDestinationSearchSelection$"
    [allDestinations$]="allDestinations$"
    [showFilters]="showFilters$ | async"
    [clearFilters$]="clearFilters$"
  >
  </fin-destination-search-form>
  <div class="fill ps-medium-b grey-25-bg border-top">
    <fin-destination-search-results
      *ngIf="initialDestinationSearchSelection$ | async"
      [content]="content"
      [viewStyle]="viewStyle"
      [selectedOriginLocationCode$]="selectedOriginLocationCode$"
      [meta]="meta"
      [filteredDestinationsWithOffers$]="filteredDestinations$"
      [isFilterApplied$]="isFilterApplied$"
      (clearAllFilters)="clearAllFilters()"
    ></fin-destination-search-results>
  </div>
</div>
